export const CirleDownAngleIcon: React.VFC<{
  className?: string;
  id?: string;
}> = ({ className, id }) => (
  <svg
    className={className}
    id={id}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.0001 9.69971L6.10322 6.79932L4.67236 8.23018L9.0001 12.5579L13.3278 8.23018L11.897 6.79932L9.0001 9.69971Z'
      fill='currentColor'
    />
    <path
      d='M9 0C4.02891 0 0 4.02891 0 9C0 13.9711 4.02891 18 9 18C13.9711 18 18 13.9711 18 9C18 4.02891 13.9711 0 9 0ZM14.3648 14.3648C12.9902 15.7395 11.0988 16.5867 9 16.5867C6.90117 16.5867 5.00977 15.7395 3.63516 14.3648C2.26055 12.9902 1.41328 11.0953 1.41328 9C1.41328 6.90469 2.26055 5.00977 3.63516 3.63516C5.00977 2.26055 6.90117 1.41328 9 1.41328C11.0953 1.41328 12.9902 2.26055 14.3648 3.63516C15.7395 5.00977 16.5867 6.90117 16.5867 9C16.5867 11.0953 15.7395 12.9902 14.3648 14.3648Z'
      fill='currentColor'
    />
  </svg>
);
